import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "../../../app/routes";
import { UrlService } from "../../../services";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const HostIndexTopbar = (props: any) => {
  const params = useParams();
  const returnUrl = UrlService.getQueryParams("returnUrl");
  const id = params["id"] ?? "";

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Host",
        icon: IconDefinitions.host,
        url: routes.host.index,
        activeMatch: routes.host.index,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Tenants",
        icon: IconDefinitions.tenant,
        url: routes.host.tenant.index,
        activeMatch: routes.host.tenant.index,
        activeMatchExact: true,
      },
      {
        label: "Subscriptions",
        icon: IconDefinitions.moneyBill,
        url: routes.host.subscription.index,
        activeMatch: routes.host.subscription.index,
        activeMatchExact: true,
      },
    ],
    [id]
  );

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default HostIndexTopbar;

